<template>
  <NodeViewWrapper>
    <div class="border border-slate-300 rounded-md">
      <div contenteditable="false" class="bg-slate-200 px-5 py-2 border-b-slate-300 border-b rounded-t-md">
        <strong>If:</strong>
        <select v-if="edit" @change="setCode" @blur="edit = false" :value="node.attrs.code" ref="input" class="p-1 ml-2">
          <option v-for="tvar in templateVariables" :key="tvar.code" :value="tvar.code">{{ tvar.code }}</option>
        </select>
        <span v-else class="text-white bg-slate-800 rounded-sm" @click.prevent="edit = true">$:{{ node.attrs.code }}:$</span>
      </div>
      <NodeViewContent class="px-5"></NodeViewContent>
    </div>
  </NodeViewWrapper>
</template>

<script setup lang="ts">
import { NodeViewContent, NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3'
import { nextTick, ref, watch } from 'vue'
import { useAdminStore } from '../../../admin/adminStore'

const props = defineProps(nodeViewProps)
const adminStore = useAdminStore()
const templateVariables = adminStore.templateVariables
const edit = ref(false)
const input = ref<HTMLInputElement>()
watch(edit, (isEdit, wasEdit) => {
  if (!wasEdit && isEdit) {
    nextTick(() => {
      input.value?.focus()
    })
  }
})
const setCode = (e: Event) => {
  const target = e.target as HTMLInputElement
  props.updateAttributes({
    code: target.value,
  })
  edit.value = false
}
</script>
